import script from "./donutChart.vue?vue&type=script&setup=true&lang=js"
export * from "./donutChart.vue?vue&type=script&setup=true&lang=js"

import "./donutChart.vue?vue&type=style&index=0&id=1459d260&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1459d260"]])

export default __exports__